import React from 'react'

const Button = ({ children, disabled = false, type = '', className = '', onClick = a => a }) => {
  return (
    <button disabled={disabled} type={type} onClick={onClick} className={`${className} p-2 m-2 rounded border-blue-6 bg-blue-6 hover:bg-blue-7 focus:outline-none focus:ring active:text-blue-2 text-blue-1 transition`}>{children}</button>
  )
}

export default Button
